import { Component } from '@nicolas-riciotti/light2';
import Lenis from '../../helpers/Lenis';
import getPosition from '../../helpers/getPosition';
import CubicBezier from '../../helpers/CubicBezier';

// Scroll-tied horizontal reveal of the big heading, with heavy temporal smoothing.
// The scroll position sets a TARGET; the rendered X eases toward it every frame,
// which absorbs the micro-steps/jumps in the raw scroll value. The background
// colour fade is removed from this block (see render.php) so this is the only
// per-frame work while scrolling through it.
const SCROLL_VIEWPORTS = 1.5;   // scroll distance the reveal spans; higher = slower
const SMOOTHING = 0.06;       // ease toward target each frame; LOWER = more easing
const EASING = [0.43, 0.195, 0.02, 1];

export default class BlockLongForm extends Component {

    created() {
        this._scroll = 0;
        this._top = 0;
        this._x = 0;            // current (smoothed) translateX
        this.titleWidth = 0;
        this.containerWidth = 0;
        this.stopped = false;
        this.onScroll = this.onScroll.bind(this);
        this.siteSettingsMotionChange = this.siteSettingsMotionChange.bind(this);
    }

    siteSettingsMotionChange(event) {
        this.stopped = ('off' === event.detail);
    }

    resize() {
        if (!this.$title) return;
        this._top = getPosition(this).top;
        this.titleWidth = this.$title.clientWidth;
        this.containerWidth = this.clientWidth;
        this._x = this.targetX();       // snap on resize so it doesn't ease from a stale value
        this.$title.style.transform = `translate3d(${this._x}px, 0, 0)`;
    }

    attached() {
        this.$title = this.querySelector('[long-form-title]');
        if (!this.$title) return;

        document.addEventListener('site_settings_motion', this.siteSettingsMotionChange, false);

        this._scroll = Lenis?.animatedScroll ?? 0;
        this.resize();
        Lenis?.on?.('scroll', this.onScroll);

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => {
                this.resize();
                requestAnimationFrame(() => this.resize());
            });
        }
    }

    detached() {
        Lenis?.off?.('scroll', this.onScroll);
        document.removeEventListener('site_settings_motion', this.siteSettingsMotionChange, false);
    }

    onScroll(e) {
        this._scroll = e.animatedScroll;
    }

    targetX() {
        const offset = (this._scroll - this._top) + (window.innerHeight * 0.9);
        const progress = Math.min(1, Math.max(0, offset / (window.innerHeight * SCROLL_VIEWPORTS)));
        const eased = this.stopped
            ? 0
            : CubicBezier(EASING[0], EASING[1], EASING[2], EASING[3], progress, 1);
        const diff = this.titleWidth - this.containerWidth;
        return -diff * eased;
    }

    update() {
        if (!this.$title) return;
        // Ease the rendered position toward the scroll target — smooths out jumps.
        this._x += (this.targetX() - this._x) * SMOOTHING;
        // Sub-pixel X on a GPU compositor layer (translate3d + will-change-transform
        // + backface-hidden on the element) composites smoothly without stepping.
        this.$title.style.transform = `translate3d(${this._x}px, 0, 0)`;
    }

}

customElements.define('block-long-form', BlockLongForm);
